import React from 'react';
import { styles } from './Breadcrumbs.css';
import { BreadcrumbItem } from './BreadcrumbItem';
import { ArrowLeftIcon } from '@jbhi-fi/lanyard-ui/components/Icons/ArrowLeft';
import { SimpleBreadcrumbs } from '@jbhi-fi/components/src/SimpleBreadcrumbs/SimpleBreadcrumbs';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

export type BreadcrumbItemProps = {
  href: string;
  label: string;
  isActive?: boolean;
  color?: string;
};

export type BreadcrumbProps = {
  items: Array<BreadcrumbItemProps>;
  maxItems?: number;
  colorHex?: string;
  className?: string;
  backgroundColor?: string;
};

const SvgWrapper = ({ children, className }: { children: React.ReactNode; className: string }) => (
  <span className={className}>{children}</span>
);

export const Breadcrumbs = ({ items, maxItems, colorHex, className, backgroundColor }: BreadcrumbProps) => {
  const color = colorHex?.includes('#') ? colorHex : `#${colorHex}`;
  const iconSize = { width: '6px', height: '12px' };
  const previousPageItem = items.length > 2 ? items[items.length - 2] : items[0];
  const isDesktop = useBreakpoint('md', 'up');

  return (
    <div className={className} style={{ backgroundColor: backgroundColor }}>
      {isDesktop ? (
        <span className={styles.desktop}>
          <SimpleBreadcrumbs breadcrumbs={items} color={color} />
        </span>
      ) : (
        <div className={styles.mobile}>
          <SvgWrapper className={styles.chevron}>
            <ArrowLeftIcon color={color} {...iconSize} />
          </SvgWrapper>
          <ol className={styles.list}>
            <li className={styles.listItem}>
              <BreadcrumbItem {...previousPageItem} color={color} label={`Back to ${previousPageItem.label}`} />
            </li>
          </ol>
        </div>
      )}
    </div>
  );
};
